<template>
  <div>
    <el-card v-if="centerTextTitle" class="analytics-card">
      <div class="analytics-center">
        <p class="card-title">{{ title }}</p>
        <p class="value">{{ centerTextValue }}</p>
        <p class="title">{{ centerTextTitle }}</p>
      </div>
      <div v-if="icon" :class="['icon', icon]">
        <UsersIcon v-if="icon === 'users'" />
        <ClockIcon v-else-if="icon === 'clock'" />
        <TrendingUpIcon v-else-if="icon === 'trending-up'" />
      </div>
    </el-card>
    <el-card v-else class="analytics-card">
      <div class="analytics-left-right">
        <p class="card-title">{{ title }}</p>
        <div class="container">
          <div class="left">
            <p :class="{ value: true, [type]: true }">{{ leftTextValue }}</p>
            <p class="title">{{ leftTextTitle }}</p>
          </div>
          <div v-if="rightTextTitle || rightTextValue" class="center-border">
            <div></div>
          </div>
          <div class="right">
            <p :class="{ value: true, [type]: true }">{{ rightTextValue }}</p>
            <p class="title">{{ rightTextTitle }}</p>
          </div>
        </div>
      </div>
      <div v-if="icon" :class="['icon', icon]">
        <UsersIcon v-if="icon === 'users'" />
        <ClockIcon v-else-if="icon === 'clock'" />
        <TrendingUpIcon v-else-if="icon === 'trending-up'" />
      </div>
    </el-card>
  </div>
</template>
<script>
import UsersIcon from './icons/UsersIcon.vue';
import ClockIcon from './icons/ClockIcon.vue';
import TrendingUpIcon from './icons/TrendingUpIcon.vue';

export default {
  components: { UsersIcon, ClockIcon, TrendingUpIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    leftTextTitle: {
      type: String,
      required: false,
    },
    leftTextValue: {
      type: [String, Number],
      required: false,
    },
    rightTextTitle: {
      type: String,
      required: false,
    },
    rightTextValue: {
      type: [String, Number],
      required: false,
    },
    centerTextTitle: {
      type: String,
      required: false,
    },
    centerTextValue: {
      type: [String, Number],
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/colors.scss';

$title-font-size: 0.85rem;

.analytics-card {
  border-radius: 0.5rem;

  ::v-deep .el-card__body {
    padding: 0.5rem 1.5rem;
    min-height: 11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }
}

p {
  margin: 0.25rem 0;
}

.analytics-center {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.card-title {
  font-size: $title-font-size;
  font-weight: 600;
  text-transform: uppercase;
}

.value {
  font-size: 1.75rem;
  font-weight: 700;
}

.title {
  font-size: $title-font-size;
  font-weight: 500;
}

.analytics-left-right {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .container {
    display: flex;
    flex-direction: row;

    .left {
      display: flex;
      flex-direction: column;

      .value {
        &.chats {
          color: $color-success;
        }

        &.active-agents {
          color: $color-primary;
        }

        &.queue-length {
          color: $color-primary;
        }

        &.response-time {
          color: $color-primary;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;

      .value {
        &.chats {
          color: $color-danger;
        }

        &.active-agents {
          color: $color-success;
        }

        &.queue-length {
          color: black;
        }

        &.response-time {
          color: black;
        }
      }
    }

    .center-border {
      padding: 0 1.5rem;

      div {
        width: 0.125rem;
        height: 100%;
        background-color: rgba($color-dark, 0.25);
      }
    }
  }
}

.icon {
  padding: 0.5rem;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ::v-deep svg {
    width: 1.5rem;
    height: 1.5rem;
    background: transparent;
  }

  &.users {
    color: $color-success;
    background-color: rgba($color-success, 0.15);
  }

  &.clock {
    color: $color-primary;
    background-color: rgba($color-primary, 0.15);
  }

  &.trending-up {
    color: $color-dark;
    background-color: rgba($color-dark, 0.15);
  }
}
</style>
